import api from '@plugins/axios'

// URL base do servidor AAWZ (sem microsservico externo)
export const API_URL = process.env.NODE_ENV === 'production' ? '' : (api.defaults.baseURL || '')

export const headers = {
  'Content-Type': 'application/json',
}
